import { CRM } from './root/CRM';


const App = () => <CRM
    logo="./img/logo_icon_light.png"
    title=""
 />;

export default App;
